export type ReportField = {
    id: string;
    displayName: string;
    fieldName: string;
    order: string;
    type: ReportFieldTypesEnum;
}

export enum ReportFieldTypesEnum {
    CDS = 'CDS',
    PROMO_PLUS_PARTICIPATION = 'Promo+ Participation',
    PROMO_PLUS_PRIZES = 'Promo+ Prizes',
}

export const ReportFieldTypeMapper : Record<ReportFieldTypesEnum, string> = {
    [ReportFieldTypesEnum.CDS]: 'CDS',
    [ReportFieldTypesEnum.PROMO_PLUS_PARTICIPATION]: 'Promo+',
    [ReportFieldTypesEnum.PROMO_PLUS_PRIZES]: 'Promo+',
}
